var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-button"},[_c('button',{staticClass:"btn-save pl-3 pr-3 pb-3 pt-5",on:{"click":function($event){return _vm.$emit('update')}}},[_vm._v(" "+_vm._s(_vm.saveText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }